import { Outlet } from 'react-router-dom'

import { LocationSettingsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/locations/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  const { data, loading } = useQuery(LocationSettingsDocument)

  if (loading) return <Loading />

  const canManageLocations = data?.locations._policies.locationManage.can ?? false

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => canManageLocations}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
